import AuthChallengeScreenJwt from 'pages/authentication/auth-email-jwt';

export default function AuthChallengeScreenJwtPage() {
  return <AuthChallengeScreenJwt />;
}
